import React from "react";
import '../../style.css';
import './dealer-label.css';

export default function DealerLabel() {
  return (
    <div className="dealer-label">
      <div className="dealer-label__inner">D</div>
    </div>
  )
}